import {
  AllInteractionsResponse,
  TripResponse,
  ProfileResponse,
  useGetInteractionsByUserQuery,
  useGetProfilesQuery,
  useGetTripsQuery,
} from '../../store/backendApi';

interface UseAccountDataReturn {
  profile: ProfileResponse | undefined;
  trips: TripResponse[] | undefined;
  interactions: AllInteractionsResponse | undefined;
  isLoadingProfile: boolean;
  isLoadingTrips: boolean;
  isLoadingInteractions: boolean;
  error: string | null;
}

/**
 * Hook to load all account-related data.
 * Platform-agnostic: Can be used in React Native.
 *
 * @returns Profile, trips, interactions data with loading states
 */
export const useAccountData = (): UseAccountDataReturn => {
  const { data: profile, isLoading: isLoadingProfile } = useGetProfilesQuery();
  const { data: trips, isLoading: isLoadingTrips } = useGetTripsQuery('admin');
  const { data: interactions, isLoading: isLoadingInteractions } = useGetInteractionsByUserQuery();

  // Simple error state - profile is required
  const error = !isLoadingProfile && !profile ? 'Profile not found' : null;

  return {
    profile,
    trips,
    interactions,
    isLoadingProfile,
    isLoadingTrips,
    isLoadingInteractions,
    error,
  };
};
